import { onAddressChangedEvent } from '../../Shared/React/js/components/addressSearch/AddressSearch';

wo$(function () {
    const controller = {
        resultDisplay: null,

        init: function () {
            controller.bind();
        },

        bind: function () {
            addEventListener(onAddressChangedEvent, function (event) {
                const customEvent = event as CustomEvent;
                const address = customEvent.detail && customEvent.detail.address;
                if (!address) {
                    if (controller.resultDisplay) {
                        controller.resultDisplay.addClass('hidden').html('');
                    }
                    return;
                }

                const senderId = customEvent.detail && (customEvent.detail.sender as string);
                const sourceElement = senderId ? document.getElementById(senderId) : null;
                if (!sourceElement) {
                    return;
                }

                const widgetContainer = wo$(sourceElement).closest('[data-widget-type="broadband-coverage-check"]');
                if (!widgetContainer || widgetContainer.length === 0) {
                    return;
                }

                controller.checkCoverage(address, widgetContainer);
            });
        },

        checkCoverage: function (address, widgetContainer) {
            if (!address || !address.label) {
                return;
            }

            controller.resultDisplay = widgetContainer.find('.speed-tier-address-entered');
            const spinner = widgetContainer.find('[data-div="widget-spinner"]');

            spinner.removeClass('hidden');
            controller.resultDisplay.addClass('hidden');

            wo$.ajax({
                url: '/Widgets/BroadbandCoverageCheck/CheckCoverage',
                type: 'GET',
                data: { address: address.label },
                success: function (response) {
                    spinner.addClass('hidden');

                    if (response && response.success === true) {
                        controller.resultDisplay.removeClass('hidden').html(response.message);
                    }
                },
                error: function (xhr, status, error) {
                    spinner.addClass('hidden');
                    console.error('Coverage check failed:', error);
                }
            });
        }
    };

    WhistleOut.initWidget = controller.init;
    controller.init();
});
